// extracted by mini-css-extract-plugin
module.exports = {"loading":"Graph-module--loading--3Nl9K","plot":"Graph-module--plot--kGfZx"};